import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import ProgramService from "../../../Services/Program.service";
import ProgramLookupModal from "./ProgramLookupModal";
const makeSearchArgs = {
    loadOptions: (search, options) => {
        var _a;
        return ProgramService.getPrograms({
            query: search,
            active: (_a = options.active) !== null && _a !== void 0 ? _a : true,
        }).then(({ programs }) => programs);
    },
    label: "fullName",
    value: "id",
};
export const ProgramSearch = makeSearch(makeSearchArgs);
export const ProgramMultiSearch = makeMultiSearch(Object.assign(Object.assign({}, makeSearchArgs), { lookupModal: ProgramLookupModal }));
